export const theBestCategories = [
  {
    name: 'Proteína',
    icon: (
      <img
        src="/images/icons/the-best-categories/proteina.svg"
        alt="Proteína"
        className="icon protein-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/suplementos/proteinas',
  },
  {
    name: 'Creatina',
    icon: (
      <img
        src="/images/icons/the-best-categories/creatina.png"
        alt="Creatina"
        className="icon creatina-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/creatina',
  },
  // {
  //   name: 'Vegano',
  //   icon: (
  //     <img
  //       src="/images/icons/the-best-categories/vegano.svg"
  //       alt="Vegano"
  //       className="icon vegan-icon"
  //     />
  //   ),
  //   url: '/categoria/ultrafarma-sports-nutrition/alimentos/opcoes-veganas',
  // },
  {
    name: 'Termogênicos',
    icon: (
      <img
        src="/images/icons/the-best-categories/termogenicos.svg"
        alt="Termogênicos"
        className="icon thermogenics-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/energia/termogenicos',
  },
  {
    name: 'Aminoácidos',
    icon: (
      <img
        src="/images/icons/the-best-categories/aminoacidos.svg"
        alt="Aminoácidos"
        className="icon amino-acids-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/suplementos/aminoacidos',
  },
  {
    name: 'Vitaminas',
    icon: (
      <img
        src="/images/icons/the-best-categories/vitaminas.svg"
        alt="Vitaminas"
        className="icon vitamins-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/vitaminas',
  },
  {
    name: 'Carboidratos',
    icon: (
      <img
        src="/images/icons/the-best-categories/carboidratos.svg"
        alt="Carboidratos"
        className="icon carbohydrates-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/energia/carboidratos-energeticos',
  },
  {
    name: 'Promoções',
    icon: (
      <img
        src="/images/icons/the-best-categories/promocoes.svg"
        alt="Promoções"
        className="icon promotions-icon"
      />
    ),
    url: '/categoria/ultrafarma-sports-nutrition/promocoes',
  },
];
